/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import PropTypes from "prop-types";
export var EuiTableBody = ({
  children,
  className,
  bodyRef,
  ...rest
}) => {
  return <tbody className={className} ref={bodyRef} {...rest}>
      {children}
    </tbody>;
};
EuiTableBody.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  bodyRef: PropTypes.any
};

try {
  // @ts-ignore
  EuiTableBody.displayName = "EuiTableBody"; // @ts-ignore

  EuiTableBody.__docgenInfo = {
    "description": "",
    "displayName": "EuiTableBody",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-label": {
        "defaultValue": null,
        "description": "",
        "name": "aria-label",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "data-test-subj": {
        "defaultValue": null,
        "description": "",
        "name": "data-test-subj",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "bodyRef": {
        "defaultValue": null,
        "description": "",
        "name": "bodyRef",
        "required": false,
        "type": {
          "name": "((instance: HTMLTableSectionElement | null) => void) | RefObject<HTMLTableSectionElement> | null | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/table/table_body.tsx#EuiTableBody"] = {
      docgenInfo: EuiTableBody.__docgenInfo,
      name: "EuiTableBody",
      path: "src/components/table/table_body.tsx#EuiTableBody"
    };
} catch (__react_docgen_typescript_loader_error) {}